import { Link } from 'react-router-dom';

export function ErrorPage({
  code,
  title,
  text,
}: {
  code: string;
  title: string;
  text: string;
}) {
  return (
    <section className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-10 text-center">
      <div className="text-[84px] font-semibold leading-none tracking-[-0.04em] text-gradient md:text-[120px]">
        {code}
      </div>
      <h1 className="mt-3 text-[28px] font-semibold tracking-tight text-ink md:text-[36px]">
        {title}
      </h1>
      <p className="mt-3 max-w-xl text-[15px] leading-6 text-muted">{text}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-xl bg-ink-gradient px-6 py-3 text-[15px] font-semibold text-white"
        >
          На главную
        </Link>
        <Link
          to="/chat"
          className="rounded-xl border border-line bg-white px-6 py-3 text-[15px] font-semibold text-ink"
        >
          Открыть чат
        </Link>
        <a
          href="mailto:help@lex.ai"
          className="rounded-xl border border-line bg-white px-6 py-3 text-[15px] font-semibold text-ink"
        >
          Написать в поддержку
        </a>
      </div>
    </section>
  );
}
